export const localStorageConstants = {
  TOKEN: "token",
  ORG_ID: "orgID",
  USER: "user",
  ROLE: "role",
};
